import { render, staticRenderFns } from "./register_Email.vue?vue&type=template&id=37a5e1d4"
import script from "./register_Email.vue?vue&type=script&lang=js"
export * from "./register_Email.vue?vue&type=script&lang=js"
import style0 from "./register_Email.vue?vue&type=style&index=0&id=37a5e1d4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports